/* Create Minicart */
/* -------------------------------------------------------------------------------------- */
function addMiniCart(event) {
  $.getJSON("/cart.js").then(
    function (cart) {
      $(".c-cart-pop-mini").addClass("active");
      $(".js-cart-items").empty();
      if (cart.item_count > 0) {
        $(".js-cart-empty").removeClass("active");
        $(".js-cart-items").addClass("active");
        $(".js-cart-min-count-cart").addClass("active");
        $(".js-cart-min-view-header").addClass("active");
        let iNote = cart.note;
        let suma = 0;
        for (let i = 0; i < cart.items.length; i++) {
          let iName = cart.items[i].product_title;
          let iId = cart.items[i].variant_id;
          let iVariant = cart.items[i].variant_title;
          let ikey = cart.items[i].key;
          let iImg = cart.items[i].image;
          let iQuantity = cart.items[i].quantity;
          let iUrl = cart.items[i].url;
          let iPrice = new Intl.NumberFormat("es-CL", {
            style: "currency",
            currency: "CLP",
          }).format(cart.items[i].line_price / 100);
          let iTotal = new Intl.NumberFormat("es-CL", {
            style: "currency",
            currency: "CLP",
          }).format(cart.items_subtotal_price / 100);
          let iOptions = cart.items[i].options_with_values;
          let iPropertiesCompare = cart.items[i].properties["productCompare"];
          let iPropertiesCompareTotal = iPropertiesCompare * iQuantity;
          let iPropertiesTag = cart.items[i].properties["productTagDiscount"];
          let iPriceCompareTotal = new Intl.NumberFormat("es-CL", {
            style: "currency",
            currency: "CLP",
          }).format(iPropertiesCompareTotal / 100);
          let iOptionsHTML = " ";
          let iProductFree =
            cart.items[i].properties.productFree !== undefined ? true : false;
          let iProductPromo =
            cart.items[i].properties.promoProducts == undefined
              ? undefined
              : cart.items[i].properties.promoProducts;
          // Discounts
          if (iPropertiesCompareTotal >= cart.items[i].line_price) {
            let iDiscountItem =
              iPropertiesCompareTotal - cart.items[i].line_price;
            suma = suma + iDiscountItem;
            $(".js-cart-content-discounts").addClass("active");
          }
          for (let i = 0; i < iOptions.length; i++) {
            let iOption =
              '<div class="c-cart-pop-mini__data-variant mb-p10">' +
              "<span>" +
              iOptions[i].name +
              ":</span>" +
              iOptions[i].value +
              "</div>";

            iOptionsHTML = iOptionsHTML + iOption;
          }
          let classPrice =
            '<p class="c-cart-pop-mini__data-old-price mb-p0 d-none">' +
            iPriceCompareTotal +
            "</p>";
          if (iPropertiesCompare != "" && !iProductFree) {
            classPrice =
              '<p class="c-cart-pop-mini__data-old-price mb-p0">' +
              iPriceCompareTotal +
              "</p>";
          }
          let classTag =
            '<span class="c-cart-pop-mini__data-discount d-none">' +
            iPropertiesTag +
            "</span>";
          if (iPropertiesTag != "" && !iProductFree) {
            classTag =
              '<span class="c-cart-pop-mini__data-discount">' +
              iPropertiesTag +
              "%</span>";
          }
          let iPriceHTML;
          if (!iProductFree) {
            iPriceHTML =
              '<div class="c-cart-pop-mini__price">' +
              classPrice +
              '<p class="d-flex align-items-center mb-p15">' +
              '<span class="c-cart-pop-mini__data-price h5">' +
              iPrice +
              "</span>" +
              classTag +
              "</p>" +
              "</div>";
          } else {
            iPriceHTML =
              '<div class="c-cart-pop-mini__price free-item__price">' +
              classPrice +
              '<p class="d-flex align-items-center">' +
              '<span class="c-cart-pop-mini__data-price h4">' +
              "GRATIS" +
              "</span>" +
              classTag +
              "</p>" +
              "</div>";
          }
          let tmpl;
          if (!iProductFree) {
            tmpl =
              '<div class="c-cart-pop-mini__list-item js-cart-min-item" data-product-id="' +
              iId +
              '" data-product-line="' +
              (i + 1) +
              '" data-product-quantity="' +
              iQuantity +
              '" data-product-promo="' +
              iProductPromo +
              '">' +
              '<div class="row">' +
              '<div class="col-4">' +
              '<a href="' +
              iUrl +
              '"><div class="c-cart-pop-mini__image" style="background: url(' +
              iImg +
              ') center center no-repeat; background-size: contain;"></div></a>' +
              "</div>" +
              '<div class="col-8">' +
              '<div class="c-cart-pop-mini__details">' +
              '<a class="link link--not-decoration mb-p10" href="' +
              iUrl +
              '"><p class="c-cart-pop-mini__data-title mb-p0">' +
              iName +
              "</p></a>" +
              iOptionsHTML +
              iPriceHTML +
              "</div>" +
              '<a class="c-cart-pop-mini__close-item js-cart-min-remove" data-product-line="' +
              (i + 1) +
              '" title="close">' +
              '<svg class="icon icon-remove" width="30px" height="30px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">' +
              '<g id="Assets" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">' +
              '<g id="icono_eliminar">' +
              '<g id="Group_2634" transform="translate(7.000000, 5.000000)" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.16666667">' +
              '<path d="M9.167,4 L0.833,4 C0.37294682,4 0,4.37294682 0,4.833 L0,11.5 C0,12.880712 1.1192881,14 2.5,14 L7.5,14 C8.1630415,14 8.798926,13.7366077 9.267767,13.267767 C9.7366077,12.798926 10,12.1630415 10,11.5 L10,4.833 C10,4.37294682 9.627053,4 9.167,4 Z" id="Vector-7"></path>' +
              '<path d="M8,2 L7.2759998,0.553 C7.10673644,0.214270592 6.7606658,0.000202218172 6.3819998,0 L3.61800002,0 C3.23933426,0.000202218172 2.89326356,0.214270592 2.72400002,0.553 L2,2 L8,2 Z" id="Vector-8"></path>' +
              '<path d="M3.333,7.333 L3.333,10.666 M6.667,7.333 L6.667,10.666 M8,2 L10,2 M2,2 L0,2" id="Vector-9"></path>' +
              "</g>" +
              '<rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>' +
              "</g>" +
              "</g>" +
              "</svg>" +
              "</a>" +
              "</div>" +
              '<div class="col-12">' +
              '<div class="c-cart-pop-mini__quantity-wrapper">' +
              '<div class="c-mini-quantity__wrapper">' +
              '<quantity-input class="c-mini-quantity js-add-minicart-quantity">' +
              '<button class="c-quantity__button no-js-hidden" name="minus" type="button">' +
              '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-minus" fill="none" viewBox="0 0 10 2" width="12" height="12">' +
              '<path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor">' +
              "</path></svg>" +
              "</button>" +
              '<input class="c-mini-quantity__input js-quantity-input" type="number" name="updates[]" value="' +
              iQuantity +
              '" min="0" id="Quantity-1" data-index="1">' +
              '<button class="c-quantity__button no-js-hidden" name="plus" type="button">' +
              '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus" fill="none" viewBox="0 0 10 10" width="12" height="12">' +
              '<path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor">' +
              "</path></svg>" +
              "</button>" +
              "</quantity-input>" +
              "</div>" +
              "</div>" +
              "</div>" +
              "</div>" +
              "</div>";
          } else {
            tmpl =
              '<div class="c-cart-pop-mini__list-item free-item__mini js-cart-min-item" data-product-key="' +
              ikey +
              '" data-product-free="' +
              cart.items[i].properties.productFree +
              '" data-product-id="' +
              iId +
              '" data-product-line="' +
              (i + 1) +
              '" data-product-quantity="' +
              iQuantity +
              '">' +
              '<div class="row">' +
              '<div class="col-12">' +
              '<div class="c-cart-pop-mini__details free-prod">' +
              '<a class="link link--not-decoration" href="' +
              iUrl +
              '"><p class="c-cart-pop-mini__data-title mb-p0">' +
              iName +
              "</p></a>" +
              iOptionsHTML +
              iPriceHTML +
              '<input disabled class="c-mini-quantity__input js-quantity-input" type="number" name="updates[]" value="' +
              iQuantity +
              '" min="0" id="Quantity-1" data-index="1">' +
              "</div>" +
              "</div>" +
              "</div>" +
              "</div>" +
              "</div>";
          }
          $(tmpl).appendTo(".js-cart-items");
          $(".js-cart-total").text(iTotal);
          $(".js-cart-min-view-cart").text(cart.item_count);
          $("[data-cart-notes]").val(iNote);
          if (cart.item_count <= 1) {
            $(".js-cart-min-view-cart").text(cart.item_count + " Artículo");
          } else if (cart.item_count > 1) {
            $(".js-cart-min-view-cart").text(cart.item_count + " Artículos");
          }
        }
        $(".js-cart-discount-total").text(
          new Intl.NumberFormat("es-CL", {
            style: "currency",
            currency: "CLP",
          }).format(suma / 100)
        );
      } else {
        let iTotal = cart.items_subtotal_price;
        $(".js-cart-total").text(iTotal);
        $(".js-cart-empty").addClass("active");
        $(".js-cart-items").removeClass("active");
        $(".js-cart-min-count-cart").removeClass("active");
        $(".js-cart-content-discounts").removeClass("active");
        $(".js-cart-min-view-header").removeClass("active");
        if (cart.item_count <= 1) {
          $(".js-cart-min-view-cart").text(cart.item_count + " Artículo");
        } else if (cart.item_count > 1) {
          $(".js-cart-min-view-cart").text(cart.item_count + " Artículos");
        }
      }
      $("[data-cart-count-bubble]").removeClass("d-none");
      $("[data-cart-count]").text(cart.item_count);
      $("[data-cart-count-bubble-total]").text(cart.items_subtotal_price);
    }.bind(this)
  );
}
/* Update Minicart */
/* -------------------------------------------------------------------------------------- */
function updateMiniCart(
  iQuantity,
  line_item,
  product_id,
  promoProducts,
  actualizar,
  event
) {
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: {
      quantity: iQuantity,
      line: line_item,
    },
    dataType: "json",
    success: function () {
      addMiniCart();
    },
    complete: function () {
      if (actualizar == true) {
        changePromoQuantities(product_id, promoProducts, iQuantity);
      }
    },
    error: function () {},
  });
}
/* Update quantity of free products */
/* -------------------------------------------------------------------------------------- */
async function changePromoQuantities(
  parentProductID,
  iProductPromo,
  iQuantity
) {
  // IF there are products free
  if (iProductPromo !== undefined && iProductPromo !== "") {
    let promoProds = iProductPromo.split(",");
    let prodsToChange = { updates: {} };
    $.getJSON("/cart.js").then(async function (cart) {
      promoProds.forEach((prod) => {
        let cartItem = cart.items.findIndex(
          (item) =>
            item.id == prod && item.properties.productFree == parentProductID
        );
        if (cartItem != -1) {
          let key = cart.items[cartItem].key;
          prodsToChange.updates[key] = iQuantity;
        }
      });
      $.ajax({
        type: "POST",
        url: "/cart/update.js",
        data: prodsToChange,
        dataType: "json",
        success: function (data) {
          addMiniCart();
        },
        error: function () {},
      });
    });
  }
}
/* Update Nota of Minicart */
/* -------------------------------------------------------------------------------------- */
function updateNoteMiniCart(iNote) {
  $.ajax({
    type: "POST",
    url: "/cart/update.js",
    data: {
      note: iNote,
    },
    dataType: "json",
    success: function () {},
    error: function () {},
  });
}
